import { getRandomEmail } from 'utils/common';
import { mockTimezoneValue, toTimezone, toUtc } from 'utils/dateTimeUtils';
import Enums from 'utils/EnumsManager';
import BaseField from './BaseField';

const FT = Enums.FieldTypes;

class DateOnly extends BaseField {
  toUtc(val) {
    return toUtc(val);
  }
  toTimezone(val) {
    return toTimezone(val);
  }
  parseValue() {
    console.warn(
      'For date/time field, please call toUtc() or toTimezone() accordingly.'
    );
    return null;
  }
  getMockedValue() {
    return mockTimezoneValue();
  }
}

class DateTime extends BaseField {
  toUtc(val) {
    return toUtc(val, true);
  }
  toTimezone(val) {
    return toTimezone(val, true);
  }
  parseValue() {
    console.warn(
      'For date/time field, please call toUtc() or toTimezone() accordingly.'
    );
    return null;
  }
  getMockedValue() {
    return mockTimezoneValue(true);
  }
}

class Email extends BaseField {
  getMockedValue() {
    return getRandomEmail();
  }
}

class LongText extends BaseField {}

class Lookup extends BaseField {
  constructor(params) {
    super(params);
    this.lookupKey = params.lookupKey;
  }
  parseValue(val) {
    if (!_.isPlainObject(val)) return null;
    return val[this.lookupKey];
  }
}

class NumberInput extends BaseField {
  getMockedValue() {
    return Math.round(Math.random() * 100);
  }
}

class PickList extends BaseField {}

class TextInput extends BaseField {}

const CustomizedFields = {
  [FT.DateOnly]: DateOnly,
  [FT.DateTime]: DateTime,
  [FT.Email]: Email,
  [FT.LongText]: LongText,
  [FT.Lookup]: Lookup,
  [FT.NumberInput]: NumberInput,
  [FT.PickList]: PickList,
  [FT.TextInput]: TextInput
};

export default CustomizedFields;



// WEBPACK FOOTER //
// ./src/models/Fields/CustomizedFields.js